<template>
<div class="quizier-module module-poll module-with-options" :style="[poll_layout == 'background' && image_preview? { backgroundImage: `url('${image_preview}')` } : '' ]">
    <div class="poll-wrapper" v-if="!show_card !== false">
        <div class="wfit poll-image animate__animated animate__jackInTheBox fast" v-if="poll_layout == 'cover'">
            <div class="wfit animate__animated img" style="animation-delay: 0.2s;">
                <img class="img-fluid" :src="image_preview" :alt="poll_question">
            </div>
        </div>
        <div class="choices-wrapper" :style="[poll_layout == 'background'? { 'background-color': question_bg_color } : '' ]" :class="[poll_layout == 'background'? question_class : '', {'no-image' : !image_preview}]">
            <h2 class="poll-question" v-html="poll_question"></h2>
            <ul class="choices-cont" :class="[{'q-list' : !is_classic}, choices_count]">
                <li class="wfit animate__animated fast animate__fadeInUp" @click="log_answer(choice, $event)" :class="[{wfit : !index}, {'list-btn' : is_classic}, {disabled : voted}]" v-for="(choice, idx) in question_choices" :id="choice.id"
                  :key="choice.id" :style="'animation-delay:'+(0.3+(idx/10))+'s'">
                    <button :class="[{'list' : is_classic}, {'grid' : !is_classic}, {disabled : voted}]">
                        <div class="img-wrapper" :class="{circled : is_circled}" data-aspect-ratio="1:1" v-if="type !== 'classic' && choice.media_path">
                            <div class="img" :style="{ backgroundImage: `url('${choice.media_path}')` }"></div>
                            <div class="poll-result default" :class="[{show : voted}, choice.id == voted_id? 'voted' : 'default']">
                                <div class="count-bar vertical" :style="{height: show_results? calc_percentage(choice.id) : '0' }"></div>
                                <div class="count-number">{{ calc_percentage(choice.id) }}</div>
                            </div>
                        </div>
                        <div class="choice-text" :class="[poll_layout == 'background'? question_class : '']" v-if="!is_classic">{{ choice.title }}</div>
                        <span v-else>{{ choice.title }}</span>
                    </button>
                    <div class="poll-result" :class="[{show : voted}, choice.id == voted_id? 'voted' : 'default']" v-if="type === 'classic'">
                        <div class="count-bar horizontal" :style="{width: show_results? calc_percentage(choice.id) : '0' }"></div>
                        <div class="count-number">{{ calc_percentage(choice.id) }}</div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="poll-wrapper endcard-screen" v-else>
        <div class="preview" v-if="endcard_media">
            <img :src="endcard_media" class="img-fluid rounded-top">
        </div>
        <div class="endcard-content" :class="{empty : !endcard_media}">
            <div class="voted-choice">
                {{ voted_text }}
            </div>
            <div class="result-description" :class="endcards_class" :style="{'background-color': endcards_bg_color}" v-html="endcard_title"></div>
            <div class="cta-btn-container cta-btn-poll" v-if="has_cta && cta_type === 'button'">
                <button-module :block_id="me.index" :result="result_id" :post_id="postID" :button="cta_button" />
            </div>
            <div class="share-widget mt-0 text-center rounded-bottom">
                <div class="share-icons mt-0">
                    <ul class="module-share-icons" v-show="social=true">
                        <li><a class="share-button social-button is-twitter"><span v-html="svg('twitter')" class="svg-gray svg-24"></span></a></li>
                        <li><a class="share-button social-button is-facebook"><span v-html="svg('facebook')" class="svg-gray svg-24"></span></a></li>
                        <li><a class="share-button social-button is-pinterest"><span v-html="svg('pinterest')" class="svg-gray svg-24"></span></a></li>
                        <li><a class="share-button social-button is-reddit"><span v-html="svg('reddit')" class="svg-gray svg-24"></span></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import mixinComponent from '../mixins';
import buttonModule from "../libs/ctaButtonModule.vue";

export default {
    props: [],
    mixins: [mixinComponent],
    data() {
        return {
            colors: 'rgba(255,255,255,1)',
            colors_alpha: 'rgba(255,255,255,0.7)',
            cards_colors: '#000000',
            cards_colors_alpha: 'rgba(0,0,0,0.7)',
            has_voted: false,
            total_votes: 0,
            show_card: false,
            end_card: null,
            voted_choice: null,
            social: false
        }
    },
    components: {
        buttonModule
    },
    computed: {
        show_results: function () {
            return this.has_block('show_results', false)
        },
        voted_id: function () {
            return this.has_block('answered_id', null)
        },
        stats: function () {
            return this.has_block('stats', null)
        },
        voted: function () {
            return this.has_block('has_answered', false)
        },
        voted_text: function () {
            const id = this.choice('id', false)
            let percentage = ''
            if (id) {
                percentage = ' - ' + this.calc_percentage(id)
            }

            return this.choice('title', false) + percentage
        },
        question_class: function () {
            return this.has('question.text_class', 'text-color-dark');
        },

        question_bg_color: function () {
            const image = this.has('question.media_path', false);
            const alpha = image ? 0.7 : 1;
            const color = image ? this.colors_alpha : this.colors;
            return this.rgbaToString('question.colors.rgba', color, alpha);
        },
        endcards_class: function () {
            return this.has('cards_text_class', 'text-color-light');
        },
        endcards_bg_color: function () {
            const image = this.endcard(`media_path`, false);
            const alpha = image ? 0.7 : 1;
            const color = image ? this.cards_colors_alpha : this.cards_colors;
            return this.rgbaToString('cards_colors.rgba', color, alpha);
        },
        image_preview: function () {
            return this.has('question.media_path', false);
        },
        poll_question: function () {
            return this.has('question.text')
        },
        question_choices: function () {
            return this.has('question.choices', []);
        },
        endcard_media: function () {
            return this.endcard('media_path', false);
        },
        endcard_title: function () {
            return this.endcard('title', false);
        },
        poll_layout: function () {
            return this.has('question.layout', 'cover');
        },
        type: function () {
            return this.has('choices_type', 'classic');
        },
        is_classic: function () {
            const type = this.has(`choices_type`, 'classic')
            return type === 'classic';
        },
        is_circled: function () {
            const type = this.has(`choices_type`, 'classic')
            return type === 'media-circle';
        },
        choices_count: function () {
            const count = this.has(`question.choices`, []).length
            let className = 'two-columns'
            if (count % 3 == 0) {
                className = 'three-columns'
            } else if (count >= 4) {
                className = 'four-columns'
            }

            return className
        },
        result_id: function () {
            return this.endcard('id', '')
        },
        has_cta: function() {
            return this.endcard('has_cta', false)
        },
        cta_type: function() {
            return this.endcard('cta_type', false)
        },
        cta_button: function() {
            return this.endcard('button', {});
        },
        cta_form: function() {
            return this.endcard('form', {});
        },
        cta_form_action: function() {
            return this.endcard('form.form_trigger', 'after');
        },
    },
    methods: {
        calc_percentage: function (id) {
            if (!this.has_block('show_results', false)) return;

            const stats = this.has_block('stats', false)
            if (stats.length > 0) {
                const index = stats.findIndex(x => x.answer_id === id);
                if (index >= 0) {
                    let votes = stats[index].total;
                    return (Math.round((votes / this.total_votes) * 100) + '%');
                }
            }

            return '0%'
        },
        get_voted_class: function (choice) {
            if (this.has_block('has_answered', false)) {
                let className = 'disabled';
                if (this.has_block('answered_id') === choice.id) {
                    className = 'active'
                }

                return className;
            }
        },
        connect_endcard: function () {
            const endcards = this.has('endcards', [])
            if (endcards.length > 0) {
                const choices = this.has('question.choices', []);
                const answered_id = this.has_block('answered_id', false)
                const id = choices.findIndex(x => x.id === answered_id);

                if (id > -1) {
                    const choice = choices[id]
                    this.voted_choice = choice
                    if (choice.card) {
                        const index = endcards.findIndex(x => x.id === choice.card);
                        this.end_card = endcards[index]
                        this.show_card = true
                    }
                }
            }
        },
        log_answer: function (choice, event) {
            if (!this.has_block('answered_id', false)) {
                const url = this.$variables.activity_url;
                if (!url) {
                    Quizier.sweetError(this.$t('i18n.somethingWentWrong'));
                    return false;
                }

                var action = {};
                action['post_id'] = this.postID;
                action['block'] = this.me.index;
                action['question'] = this.me.index;
                action['voted'] = choice.id;
                action['url'] = url;

                this._updateMe(`answered_id`, choice.id)
                if (!this.is_preview) {
                    axios.post(url, action).then(res => {
                        if (!res.data.error) {
                            this._updateMe(`has_answered`, true)
                        }

                        if (res.data.action.data.stats) {
                            this._updateMe('stats', res.data.action.data.stats);
                        } else if (res.data.error) {
                            this.resetAns(res.data.action.message || false)
                        }
                    }).catch(err => {
                        this.resetAns(err.response.data.message)
                        return false;
                    });
                } else {
                    let $previewStats = [{
                        'total': 1,
                        'answer_id': choice.id,
                    }];
                    this._updateMe(`has_answered`, true);
                    this._updateMe('stats', $previewStats);
                }
            }
        },
        resetAns: function (message = false) {
            this._updateMe(`has_answered`, false)
            this._updateMe(`answered_id`, null)
            if (message) {
                Quizier.sweetError(message)
            }
        },
        endcard: function (prop, def) {
            return this.deepget(this.end_card, prop, def);
        },
        choice: function (prop, def) {
            return this.deepget(this.voted_choice, prop, def);
        }
    },
    mounted: function () {
        if (this.has_block('has_answered', false)) {
            const $this = this;
            setTimeout(function () {
                $this._updateMe('show_results', true)
            }, 1500);
        }
    },
    watch: {
        stats: function (stats, oldStats) {
            if (stats) {
                const choices = this.has('question.choices', []);
                this.total_votes = stats.reduce((a, {
                    total,
                    answer_id
                }) => {
                    const index = choices.findIndex(x => x.id === answer_id);
                    if (index >= 0) {
                        return a + total
                    }
                    return a;
                }, 0);
            }

            this._updateMe('show_results', true)
        },
        show_results: function (has_answered, oldAns) {
            const $this = this;
            setTimeout(function () {
                $this.connect_endcard()
            }, 5000);
        },
        social: function () {
            Quizier.setupSocial();
        }
    }
}
</script>
